module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group pull-left"
  }, [_c('el-radio-group', {
    nativeOn: {
      "change": function($event) {
        _vm.$emit('changeRegion', _vm.getRegion())
      }
    },
    model: {
      value: (_vm.selectedRegion),
      callback: function($$v) {
        _vm.selectedRegion = $$v
      },
      expression: "selectedRegion"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "type": "primary",
      "label": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.regions), function(region) {
    return _c('el-radio-button', {
      key: region.code,
      attrs: {
        "type": "primary",
        "label": region.code
      }
    }, [_vm._v(_vm._s(region.name) + "\n            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('el-radio-group', {
    nativeOn: {
      "change": function($event) {
        _vm.$emit('changeDate', _vm.getDateRange())
      }
    },
    model: {
      value: (_vm.selectedRange),
      callback: function($$v) {
        _vm.selectedRange = $$v
      },
      expression: "selectedRange"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "30 Days"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3 Months"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "6 Months"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "12 Months"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "data-table-container"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "msg": "Loading Station Activity"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('el-table', {
    staticClass: "data-table",
    attrs: {
      "row-key": "key",
      "size": "small",
      "stripe": "",
      "data": _vm.stationActivityData.results
        .filter(
          function (data) { return !_vm.searchTerm ||
          data.name.toLowerCase().includes(_vm.searchTerm.toLowerCase()) ||
          data.organization.toLowerCase().includes(_vm.searchTerm.toLowerCase()); }
        )
        .slice(0, 10),
      "cell-style": _vm.cellStyle,
      "tree-props": {
        children: 'users'
      }
    }
  }, [_c('el-table-column', [_c('template', {
    slot: "header"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "placeholder": "Station search"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "sortable": "",
      "prop": "name",
      "label": "Station"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: {
            'bold-name': scope.row.is_admin
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 1991868326)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "220",
      "sortable": "",
      "prop": "name",
      "label": "Organization"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.organization))])]
      }
    }], null, false, 1820501917)
  })], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "height": "80",
      "align": "center",
      "label": "Users"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "sortable": "",
      "prop": "last_activity",
      "align": "center",
      "label": "Last Activity"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.last_activity)))])]
      }
    }], null, false, 1489632776)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "sortable": "",
      "prop": "no_users",
      "align": "center",
      "label": "No. Users"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "perc_active",
      "align": "center",
      "label": "% Active"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Campaigns"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "campaigns_last_created",
      "align": "center",
      "label": "Last Created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.campaigns_last_created)))])]
      }
    }], null, false, 759395255)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "campaigns_no_created",
      "align": "center",
      "label": "No. Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "campaigns_no_active",
      "align": "center",
      "label": "No. Active"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Surveys"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_last_created",
      "align": "center",
      "label": "Last Created"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(scope.row.surveys_last_created)))])]
      }
    }], null, false, 3486337655)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_no_created",
      "align": "center",
      "label": "No. Created"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_no_active",
      "align": "center",
      "label": "No. Active"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_latest_n",
      "align": "center",
      "label": "Latest n"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "surveys_avg_n",
      "align": "center",
      "label": "Avg n"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Messages"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "messages",
      "align": "center",
      "label": "F",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [(scope.row.messages[0].facebook_post || scope.row.messages[0].facebook_comment) ? _c('span', [_vm._v(_vm._s(_vm.formatNumber(
          scope.row.messages[0].facebook_post + scope.row.messages[0].facebook_comment
        )))]) : _vm._e()] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].tweet",
      "align": "center",
      "label": "T",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].tweet)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].instagram",
      "align": "center",
      "label": "I",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].instagram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].whatsapp",
      "align": "center",
      "label": "W",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].whatsapp)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].telegram",
      "align": "center",
      "label": "TE",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].telegram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].facebook_message",
      "align": "center",
      "label": "FM",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].facebook_message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].message",
      "align": "center",
      "label": "SMS",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "messages[0].email",
      "align": "center",
      "label": "E",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages && scope.row.messages.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.messages[0].email)))])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Unique Users"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "unique_users",
      "align": "center",
      "label": "F",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [(
          scope.row.unique_users[0].facebook_post ||
          scope.row.unique_users[0].facebook_comment
        ) ? _c('span', [_vm._v(_vm._s(_vm.formatNumber(
          scope.row.unique_users[0].facebook_post +
          scope.row.unique_users[0].facebook_comment
        )))]) : _vm._e()] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].tweet",
      "align": "center",
      "label": "T",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].tweet)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].instagram",
      "align": "center",
      "label": "I",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].instagram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].whatsapp",
      "align": "center",
      "label": "W",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].whatsapp)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].telegram",
      "align": "center",
      "label": "TE",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].telegram)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].facebook_message",
      "align": "center",
      "label": "FM",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].facebook_message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].message",
      "align": "center",
      "label": "SMS",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].message)))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_users[0].email",
      "align": "center",
      "label": "E",
      "render-header": _vm.renderIcon
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.unique_users && scope.row.unique_users.length > 0) ? [_c('span', [_vm._v(_vm._s(_vm.formatNumber(scope.row.unique_users[0].email)))])] : undefined
      }
    }], null, true)
  })], 1), _vm._v(" "), _c('el-table-column', [_c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "qualitative_surveys",
      "align": "center",
      "label": "Qualitative"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.qualitative_surveys),
            callback: function($$v) {
              _vm.$set(scope.row, "qualitative_surveys", $$v)
            },
            expression: "scope.row.qualitative_surveys"
          }
        })]
      }
    }], null, false, 540383583)
  })], 1), _vm._v(" "), _c('el-table-column', [_c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "is_streaming",
      "align": "center",
      "label": "Streaming"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.is_streaming),
            callback: function($$v) {
              _vm.$set(scope.row, "is_streaming", $$v)
            },
            expression: "scope.row.is_streaming"
          }
        })]
      }
    }], null, false, 2630274767)
  })], 1), _vm._v(" "), (_vm.selectedRegion === 'ZA' || _vm.selectedRegion === '') ? _c('el-table-column', [_c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "afstereo",
      "align": "center",
      "label": "AFStereo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.afstereo),
            callback: function($$v) {
              _vm.$set(scope.row, "afstereo", $$v)
            },
            expression: "scope.row.afstereo"
          }
        })]
      }
    }], null, false, 4246715691)
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.stationActivityData.count
    },
    on: {
      "current-change": function($event) {
        _vm.$emit('changePage', _vm.getPageChange($event))
      }
    }
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_c('span', [_vm._v("Station Activity Dashboard")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f6471a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/admin/StationActivityDashboard.vue
// module id = 3122
// module chunks = 3